import { postPurchaseFlowStepArraySchema } from "@redotech/redo-flows-common/advanced-flow-db-parser";
import * as z from "zod";

export const updatePostPurchaseFlow = {
  name: "updatePostPurchaseFlow" as const,
  input: postPurchaseFlowStepArraySchema,
  output: z.null(),
};
